// (07/10/2026) GỘP: thẻ "Chạy kịch bản" DUY NHẤT của trang #/kich-ban/:id (trước đây hai thẻ "Chạy trên một bot" + "Chạy trên nhiều bot").
// Chọn bot bằng ô tick (1 bot cũng được; mặc định tick sẵn bot macDinhBot hoặc ?botIds=). Đúng 1 bot → nút gọn "Chạy thử"/"Chạy thật" gọi API
// MỘT bot (POST /nhap, /chay-that: máy chủ ghi lần chạy vào kịch bản → kết quả từng bước trên sơ đồ, tự sửa, nháp lại, chuỗi); ≥ 2 bot → "Chạy thử
// trên N bot" + ô lệch giờ + thử trên 1 bot trước, API nhiều bot như dưới. Phần chỉ thuộc về trang chính (công tắc Tự động, dòng kết quả 1 bot + Duyệt,
// Xuất, Xoá kịch bản, chờ lưu sơ đồ) do kich-ban.ts đưa vào qua `mot` (MotBot).
// --- phần "nhiều bot" (docs/thiet-ke-mau-super.md mục 2) ---
// Tick bot (có "Chọn tất cả bot trực tuyến phù hợp nền tảng") → Chạy thử / Chạy thật trên N bot → bảng tiến độ TỪNG bot (máy chủ trả), Dừng
// (huỷ lệnh có sẵn), Duyệt/Từ chối bước rủi ro, "Cho phép chạy thật trên …" cho bot chưa được phép. Bot nào hỏng cổng → máy chủ bỏ qua kèm
// lý do; trang chỉ hiện lại đúng lý do đó. Mọi chữ dựng bằng textContent.
// N5 (rà soát 05/10/2026): bấm "Chạy thật trên N bot" → KIỂM TRƯỚC (POST /kiem-chay-that-nhieu, không tạo lệnh) → hộp xác nhận nói ĐÚNG bot nào
// chạy / bot nào không (kèm lý do); bot chỉ thiếu "được phép chạy thật" → nút "Cho phép chạy thật trên N bot này" (một lần, có xác nhận —
// POST /cho-phep-chay-that) rồi hỏi chạy luôn. Trước đây hộp xác nhận hứa "Các bot … sẽ làm THẬT" rồi cả 10 bot bị bỏ qua, phải sửa từng bot.
// N11 (docs/phuong-an-gom-loi-chay.md T3/T4/T13, người dùng chốt Q3): chọn ≥ 2 bot → ô "Bắt đầu lệch nhau" riêng cho chạy thử (mặc định Cùng
// lúc) và chạy thật (mặc định ≤ 3 phút) + "Thử trên 1 bot trước" (chỉ chạy thật, mặc định bật). Bot chạy trước bị trang từ chối → hộp cam
// Tiếp tục / Huỷ ngay trong thẻ (POST /api/jobs/:id/canary-continue có sẵn). Bot chờ giãn cách hiện "đang chờ tới lượt (bắt đầu lúc hh:mm)".
// `chonSan`: mã bot tick sẵn (từ ?botIds= của trang kịch bản) — mã không có trong danh sách bot bị bỏ. Liên kết "Lịch sử chạy của kịch bản này".
// Lần hỏi lại 1,5 s CHỈ vẽ lại phần tiến độ (ô đang gõ số giây không mất con trỏ); ô tuỳ chọn là phần tử giữ nguyên qua các lần vẽ.
import { api, ApiError, errMsg } from "../api";
import { busy, clear, confirmBox, h, toast } from "../dom";
import { fmtDuKien, fmtTime, runStatusText } from "../format";
import { ganLyDo } from "../ten-kb";
import { canhBaoBotMang, chipBotMang, taiBotMang, tenMangCoDinh as tenMangTrang, type BotMangMap } from "../bot-mang"; // L-99: mạng bot đã chạy được + mạng đang tạm dừng
import type { Bot } from "../types";
import { NHAC_CHAY_THAT_SP } from "./kich-ban-chua-sp";

const HOI_LAI_MS = 1500;

interface BotLo { botId: string; botName: string; runKey: string; trangThai: string; lyDo: string | null; ma?: string; ketThuc: boolean; sach: boolean | null; dungHash: boolean; choDuyet: { runKey: string; moTa: string; noiDung?: string } | null; batDauLuc?: string | null }
interface Lo { jobId: string; mode: "draft" | "live"; taoLuc: string; jobTrangThai: string | null; jobLyDo: string | null; ketThuc: boolean; dungDuoc: boolean; gianCachS?: number; canaryBotId?: string | null; bots: BotLo[] }
interface TrangThai { nhap: Lo | null; that: Lo | null }
interface BoQua { botId: string; botName: string; lyDo: string; ma?: string }
// chuaGanSp (05/10/2026): kịch bản có bước soạn nội dung mà chưa gắn sản phẩm → hộp xác nhận Chạy thật có dòng nhắc (không chặn).
export interface KbChoNhieuBot { id: string; ten: string; trangThai: string; coSoDo: boolean; nenTang: string; bundleName: string | null; botGoiY?: string[]; chuaGanSp?: boolean }
/** Phần của thẻ do trang chính (kich-ban.ts) giữ trạng thái: gọi lại mỗi lần vẽ thẻ. */
export interface MotBot {
  /** (16/10/2026) Mặc định "Chạy thật — bắt đầu lệch nhau" (giây, một trong LUA_CHON_GIAN_CACH); Kho mẫu = "600" để các nick không cùng bấm một lúc. Thiếu = "180". */
  macDinhGianCachThat?: string;
  /** Bot tick sẵn khi người dùng chưa tự chọn (macDinhBot của trang); "" = không bot nào. */
  macDinh(): string;
  /** Cổng chạy thật chung của kịch bản (d.choChayThat): dùng cho nút "Chạy thật" khi chọn đúng 1 bot. */
  choChayThat(): { duoc: boolean; lyDo: string };
  /** Số bước rủi ro cao đang đặt TỰ ĐỘNG (nói trong hộp xác nhận Chạy thật). */
  soBuocTuDong(): number;
  /** Công tắc "Tự động tất cả bước rủi ro cao" + dải cảnh báo cam. */
  theTuDong(): HTMLElement[];
  /** Dòng kết quả lần chạy thử/thật MỘT bot (kb-nhap-tt / kb-that-tt) + hộp Chờ duyệt (kb-duyet / kb-tu-choi). */
  veLanChay(): HTMLElement[];
  /** Nút cuối hàng nút: khoảng đệm + Xuất + Xoá kịch bản. */
  nutPhu(): HTMLElement[];
  /** Chờ hàng đợi lưu sơ đồ xong (sơ đồ trên màn hình phải là bản đã lưu trước khi chạy). */
  choXong(): Promise<void>;
  /** Máy chủ trả chi tiết kịch bản sau Chạy thử / Chạy thật một bot → trang chính nhận, vẽ lại, hỏi lại tiến độ. */
  sauChayMot(kichBan: unknown): void;
  /** Bot mới nhất (store theo WS mới hơn danh sách lúc mở trang) — kiểm trước "chưa được phép chạy thật". */
  botMoiNhat(id: string): Bot | undefined;
  /** (07/10/2026, GĐ0 pha B) Các dòng ĐỎ của sơ đồ ĐANG HIỆN trên màn hình (kể cả thao tác còn chờ lưu); rỗng = không đỏ. Đỏ → Chạy thử / Chạy thật hiện danh sách này, không gọi API. */
  buocDo?(): BuocDoDong[];
  /** Cuộn tới bước số `soThuTu` (từ 1) trong sơ đồ. */
  nhayToiBuoc?(soThuTu: number): void;
}
/** Một dòng bước đỏ: `loi` = câu đầy đủ ("Bước 3 (Tên): thiếu …"). */
export interface BuocDoDong { soThuTu: number; tieuDe: string; loi: string }
// Câu trang tự báo khi bot chưa được phép chạy thật (cùng ý với máy chủ; quét d-vi cấm chữ "job"/"live" trên giao diện).
const MSG_CHUA_DUOC_CHAY_THAT = "Không có bot nào chạy được lệnh này";
const MSG_CHUA_WHITELIST = "Chưa được phép chạy thật trên bot này";
const MSG_CHUA_CHON_BOT = "Chọn bot sẽ chạy kịch bản này (máy không tự chọn khi chưa rõ bot nào đã đăng nhập mạng này)";
const MSG_CHUA_CO_BOT = "Chưa có bot nào — ghép cặp bot ở trang Bot";

// ---- N11: "Bắt đầu lệch nhau" (giây) ----
export const GIAN_CACH_TOI_DA_S = 3600;
export const LUA_CHON_GIAN_CACH: { giaTri: string; nhan: string }[] = [
  { giaTri: "0", nhan: "Cùng lúc" },
  { giaTri: "60", nhan: "Lệch nhau tối đa 1 phút" },
  { giaTri: "180", nhan: "Lệch nhau tối đa 3 phút" },
  { giaTri: "600", nhan: "Lệch nhau tối đa 10 phút" },
  { giaTri: "tu", nhan: "Tự nhập số giây…" },
];
/** Số giây từ lựa chọn (`tu` = đọc ô tự nhập: chỉ chữ số ASCII, số nguyên 0–3600). Sai → null. */
export function docGianCach(luaChon: string, tuNhap: string): number | null {
  const s = luaChon === "tu" ? tuNhap.trim() : luaChon;
  if (!/^[0-9]{1,5}$/.test(s)) return null;
  const n = Number(s);
  return n >= 0 && n <= GIAN_CACH_TOI_DA_S ? n : null;
}
/** 0 → "cùng lúc"; 180 → "lệch nhau ngẫu nhiên tối đa 3 phút"; 90 → "… tối đa 90 giây". */
export function moTaGianCach(giay: number): string {
  if (giay <= 0) return "cùng lúc";
  return `lệch nhau ngẫu nhiên tối đa ${giay % 60 === 0 ? `${giay / 60} phút` : `${giay} giây`}`;
}
/** Lý do máy chủ ghi bằng chữ kỹ thuật "canary" (jobs.ts) → câu tiếng Việt cho người dùng. */
export function lyDoDeHieu(s: string | null): string | null {
  if (!s) return s;
  if (/huỷ sau canary/i.test(s)) return "Bạn đã huỷ sau khi bot chạy trước bị trang web từ chối";
  if (/^canary thất bại/i.test(s)) return "Bot chạy trước bị lỗi nên bot này không chạy";
  return s.replace(/^Canary bị site từ chối:\s*/i, "");
}

// sauGui: máy chủ vừa đổi kịch bản (Nháp → Chạy thử khi chạy thử; ảnh chụp bài học mới) → trang chính tải lại chi tiết (đầu trang, trạng thái).
// chonSan (N11): mã bot tick sẵn khi mở trang (vd từ hộp "Chạy gì trên bot này?") — chỉ giữ mã có trong danh sách bot của Boss.
export function taoTheNhieuBot(box: HTMLElement, layKb: () => KbChoNhieuBot, layBots: () => Bot[], doiBot: (b: Bot) => void, sauGui: () => void, chonSan: string[] | undefined, mot: MotBot): { ve: () => void; huy: () => void } {
  const chon = new Set<string>();
  let choChonSan: string[] | null = chonSan?.length ? [...new Set(chonSan)] : null;
  // Chưa tự chọn (không có ?botIds=, chưa tick / bỏ tick lần nào) → tick = bot mặc định của trang, tính lại mỗi lần vẽ (như ô chọn bot cũ).
  let daTuChon = !!choChonSan;
  let tt: TrangThai = { nhap: null, that: null };
  let boQuaMoi: { mode: string; ds: BoQua[] } | null = null;
  let kiem: { chay: { botId: string; botName: string }[]; boQua: BoQua[] } | null = null; // N5: kết quả kiểm trước chạy thật (khung nb-kiem)
  const CHUA_PHEP = "not_whitelisted";
  // ---- N11: ô tuỳ chọn (một phần tử giữ nguyên qua các lần vẽ lại — không mất chữ / con trỏ khi trang hỏi lại tiến độ) ----
  const taoChonGc = (testid: string, macDinh: string, nhan: string): { sel: HTMLSelectElement; so: HTMLInputElement; o: HTMLElement } => {
    const sel = h("select", { "data-testid": testid, title: `${nhan}: các bot bắt đầu cùng lúc hay lệch nhau ngẫu nhiên tới tối đa chừng này (giống người thật, đỡ bị trang web nghi)` },
      ...LUA_CHON_GIAN_CACH.map((x) => h("option", { value: x.giaTri }, x.nhan))) as HTMLSelectElement;
    sel.value = macDinh;
    const so = h("input", { type: "text", inputmode: "numeric", maxlength: "8", placeholder: "số giây 0–3600", "data-testid": `${testid}-so`, title: "Số giây nguyên từ 0 đến 3600", class: "nb-gc-so", hidden: true }) as HTMLInputElement;
    const o = h("div", { class: "f nb-gc" }, h("span", { class: "f-nhan" }, nhan), h("div", { class: "row nb-gc-dong" }, sel, so));
    sel.addEventListener("change", () => { so.hidden = sel.value !== "tu"; if (!so.hidden) so.focus(); kiemGc(); });
    so.addEventListener("input", () => kiemGc());
    return { sel, so, o };
  };
  const gcNhap = taoChonGc("nb-gc-nhap", "0", "Chạy thử — bắt đầu lệch nhau");
  const gcThat = taoChonGc("nb-gc-that", mot.macDinhGianCachThat ?? "180", "Chạy thật — bắt đầu lệch nhau");
  const gcLoi = h("p", { class: "err small", "data-testid": "nb-gc-loi", hidden: true, role: "alert" });
  const tuyChon = h("div", { class: "nb-tuy-chon", "data-testid": "nb-tuy-chon", hidden: true },
    h("div", { class: "field-row" }, gcNhap.o, gcThat.o),
    gcLoi);
  const cheDoGc = (mode: "draft" | "live") => (mode === "draft" ? gcNhap : gcThat);
  /** Số giây đang chọn cho chế độ; sai → null. */
  const giayGc = (mode: "draft" | "live"): number | null => { const g = cheDoGc(mode); return docGianCach(g.sel.value, g.so.value); };
  const MSG_GC = (mode: "draft" | "live") => `Bắt đầu lệch nhau khi ${mode === "draft" ? "chạy thử" : "chạy thật"} phải là số giây nguyên từ 0 đến ${GIAN_CACH_TOI_DA_S}`;
  /** Báo sai ngay dưới ô (ô "Tự nhập" đã gõ mà sai). Có `mode` → kiểm bắt buộc chế độ đó (lúc bấm Chạy), trả câu lỗi (nếu có). */
  function kiemGc(mode?: "draft" | "live"): string | null {
    const loi = mode && giayGc(mode) === null ? MSG_GC(mode) : null;
    const sai = (["draft", "live"] as const).find((m) => cheDoGc(m).sel.value === "tu" && cheDoGc(m).so.value !== "" && giayGc(m) === null);
    const hien = loi ?? (sai ? MSG_GC(sai) : null);
    gcLoi.textContent = hien ?? "";
    gcLoi.hidden = !hien;
    return loi;
  }
  /** Trường gửi máy chủ theo chế độ (chỉ khi ≥ 2 bot sẽ chạy; 1 bot thì không giãn, không thử trước). */
  function truongThem(mode: "draft" | "live", soBot: number): { gianCachS?: number } {
    if (soBot < 2) return {};
    const g = giayGc(mode) ?? 0;
    return { gianCachS: g }; // (09/10/2026) bỏ "Thử trên 1 bot trước": mọi bot bắt đầu theo lệch giờ, không chờ bot nào
  }
  const lyDoSpan = (s: string): HTMLElement => { const x = h("span", { class: "nb-ly-do" }); ganLyDo(x, layKb().bundleName ?? "", s); return x; };
  /** Nút "Cho phép chạy thật trên N bot này" (N ≥ 1) cho các bot chỉ thiếu quyền chạy thật; xong → `sau()` (vd kiểm lại rồi hỏi chạy). */
  function nutChoPhepNhieu(ds: BoQua[], testid: string, sau: () => void): HTMLButtonElement | null {
    const can = ds.filter((x) => x.ma === CHUA_PHEP);
    if (!can.length) return null;
    const kb = layKb();
    const nut = h("button", { type: "button", class: "pri mini", "data-testid": testid, title: "Thêm kịch bản này vào danh sách được chạy thật của các bot này (như ở trang Bot) — một lần cho tất cả" }, `Cho phép chạy thật trên ${can.length} bot này`);
    nut.addEventListener("click", () => void (async () => {
      const ten = can.map((x) => x.botName).join(", ");
      if (!(await confirmBox({ title: `Cho phép chạy thật trên ${can.length} bot?`, okText: "Cho phép", text: `Kịch bản “${kb.ten}” được phép chạy THẬT trên: ${ten}. Chỉ chạy khi bạn bấm Chạy thật; bước rủi ro cao vẫn dừng hỏi bạn duyệt (trừ bước bạn đặt Tự động).` }))) return;
      await busy(nut, "Đang cho phép…", async () => {
        try {
          const r = await api<{ choPhep: string[]; bots: Bot[] }>("POST", `/api/kich-ban/${encodeURIComponent(kb.id)}/cho-phep-chay-that`, { botIds: can.map((x) => x.botId) });
          for (const b of r.bots) doiBot(b);
          toast(`Đã cho phép chạy thật trên ${can.length} bot`);
          sau();
        } catch (e) { toast(errMsg(e), "err"); }
      });
    })());
    return nut;
  }
  let timer: number | undefined;
  let loBox: HTMLElement | null = null;
  let song = true;
  // L-99: dữ liệu mạng của bot (GET /api/bots/mang); lỗi mạng → {} (không chip). Tải lúc mở thẻ, vẽ lại thẻ MỘT lần khi có dữ liệu.
  let botMang: BotMangMap = {};
  void taiBotMang().then((m) => { botMang = m; if (song && Object.keys(m).length) ve(); });
  let daTai = false;
  let dangGui = false; // trang chính vẽ lại thẻ trong lúc đang gửi → nút mới vẫn khoá (bấm 2 lần = 1 lệnh)
  // (07/10/2026, GĐ0 pha B) Sơ đồ còn bước ĐỎ: nút Chạy thử / Chạy thật vẫn BẤM ĐƯỢC — bấm → hiện danh sách bước đỏ (trang đã biết nên KHÔNG gọi API, console không có lỗi);
  // bước VÀNG không chặn. `bamDo` = người dùng vừa bấm khi còn đỏ (danh sách hiện theo sơ đồ đang có, ngắn dần khi sửa); `loiMayChu` = danh sách máy chủ trả (400 details.buocDo)
  // khi trang chưa biết (lệch thời điểm) — hiện tới lần bấm kế tiếp.
  let bamDo = false;
  let loiMayChu: BuocDoDong[] | null = null;
  const buocDoTuLoi = (e: unknown): BuocDoDong[] | null => {
    if (!(e instanceof ApiError) || !e.details || typeof e.details !== "object") return null;
    const b = (e.details as { buocDo?: { soThuTu: number; tenNgan: string; lyDo: string }[] }).buocDo;
    return Array.isArray(b) && b.length ? b.map((x) => ({ soThuTu: x.soThuTu, tieuDe: x.tenNgan, loi: `Bước ${x.soThuTu} (${x.tenNgan}): ${x.lyDo}` })) : null;
  };
  /** Còn bước đỏ → hiện danh sách và trả true (người gọi dừng, không gọi API). */
  function chanNeuDo(): boolean {
    if (!(mot.buocDo?.() ?? []).length) return false;
    bamDo = true; loiMayChu = null; kiem = null; boQuaMoi = null;
    ve();
    box.querySelector<HTMLElement>('[data-testid="kb-chay-do"]')?.scrollIntoView({ block: "nearest" });
    return true;
  }
  /** Máy chủ từ chối vì bước đỏ (400 details.buocDo) → hiện danh sách; trả true nếu đúng loại lỗi đó. */
  function baoNeuBuocDo(e: unknown): boolean {
    const ds = buocDoTuLoi(e);
    if (!ds) return false;
    loiMayChu = ds; bamDo = false;
    ve();
    return true;
  }

  const tai = async (): Promise<void> => {
    const kb = layKb();
    const dangTruoc = (!!tt.nhap && !tt.nhap.ketThuc) || (!!tt.that && !tt.that.ketThuc);
    tt = await api<TrangThai>("GET", `/api/kich-ban/${encodeURIComponent(kb.id)}/nhieu-bot`);
    daTai = true;
    // V8: lần chạy nhiều bot vừa XONG → trang chính tải lại chi tiết (dòng kết quả chạy một bot + đầu trang dùng cùng kết quả chạy thử — không còn
    // "Chưa chạy thử" bên cạnh "xong 10/10, sạch").
    if (dangTruoc && !((!!tt.nhap && !tt.nhap.ketThuc) || (!!tt.that && !tt.that.ketThuc))) sauGui();
    if (song) { if (loBox?.isConnected) veLo(); else ve(); }
  };
  const canHoi = (): boolean => (!!tt.nhap && !tt.nhap.ketThuc) || (!!tt.that && !tt.that.ketThuc);
  const hoiLai = (): void => {
    window.clearTimeout(timer);
    if (!song || !canHoi()) return;
    timer = window.setTimeout(() => void tai().catch(() => null).finally(hoiLai), HOI_LAI_MS);
  };

  // ---- N5: Chạy thật = kiểm trước → (không bot nào được: chỉ hiện lý do + nút Cho phép) / hộp xác nhận nói đúng bot chạy + bot không chạy ----
  let guiHienTai: ((mode: "draft" | "live", them?: { gianCachS?: number }) => Promise<void>) | null = null; // hàm gửi của lần vẽ hiện tại (ve)
  let dangKiem = false;
  async function chayThat(btn: HTMLButtonElement | null): Promise<void> {
    if (dangGui || dangKiem || !chon.size) return;
    if (chanNeuDo()) return; // (07/10/2026) còn bước đỏ → hiện danh sách, không kiểm / không chạy
    if (chon.size >= 2 && kiemGc("live")) { gcLoi.scrollIntoView({ block: "nearest" }); return; }
    const kb = layKb();
    dangKiem = true;
    let k: { chay: { botId: string; botName: string }[]; boQua: BoQua[] };
    try {
      await mot.choXong(); // (07/10/2026) sơ đồ trên màn hình phải là bản đã lưu trước khi kiểm / chạy
      const hoi = () => api<{ chay: { botId: string; botName: string }[]; boQua: BoQua[] }>("POST", `/api/kich-ban/${encodeURIComponent(kb.id)}/kiem-chay-that-nhieu`, { botIds: [...chon] });
      let kq: typeof k | null = null;
      if (btn) await busy(btn, "Đang kiểm…", async () => { kq = await hoi(); }); else kq = await hoi();
      if (!kq) return;
      k = kq;
    } catch (e) { dangKiem = false; if (!baoNeuBuocDo(e)) toast(errMsg(e), "err"); return; } finally { dangKiem = false; }
    if (!song) return;
    kiem = k;
    boQuaMoi = null;
    ve();
    if (!k.chay.length) { box.querySelector<HTMLElement>('[data-testid="nb-kiem"]')?.scrollIntoView({ block: "nearest" }); return; }
    const khong = k.boQua.length ? ` ${k.boQua.length} bot KHÔNG chạy: ${k.boQua.map((x) => `${x.botName} — ${x.lyDo}`).join("; ")}.` : "";
    // N11: chỉ khi ≥ 2 bot THẬT SỰ chạy mới giãn cách / thử trước (1 bot thì chạy ngay — không bắt chờ vô ích).
    const them = truongThem("live", k.chay.length);
    const soTuDong = mot.soBuocTuDong();
    const cachChay = them.gianCachS === undefined ? "" : ` Các bot bắt đầu ${moTaGianCach(them.gianCachS)}.`;
    if (!(await confirmBox({ title: `Chạy thật trên ${k.chay.length} bot?`, okText: "Chạy thật", danger: true,
      text: `${k.chay.length === 1 ? "Bot" : "Các bot"} ${k.chay.map((x) => x.botName).join(", ")} sẽ làm THẬT các bước của kịch bản “${kb.ten}”.${khong}${cachChay} ${soTuDong ? `${soTuDong} bước đặt TỰ ĐỘNG sẽ gửi/đăng KHÔNG hỏi duyệt (bạn chịu trách nhiệm nội dung); bước rủi ro cao còn lại dừng hỏi bạn duyệt trên từng bot.` : "Bước rủi ro cao (gửi/đăng/thích) dừng hỏi bạn duyệt trên từng bot."}`, nhac: layKb().chuaGanSp ? NHAC_CHAY_THAT_SP : undefined }))) return;
    if (!song) return;
    kiem = null;
    const nut = box.querySelector<HTMLButtonElement>('[data-testid="kb-that"]');
    const g = guiHienTai;
    if (!g) return;
    if (nut) await busy(nut, "Đang gửi…", () => g("live", them)); else await g("live", them);
  }

  function phuHop(): string[] {
    const kb = layKb();
    const tren = layBots().filter((b) => b.online);
    const goiY = (kb.botGoiY ?? []).filter((id) => tren.some((b) => b.id === id));
    return goiY.length ? goiY : tren.map((b) => b.id);
  }

  function dongBot(b: BotLo, lo: Lo): HTMLElement {
    // N9: lý do có mã bước ("lay_bai: 0 mục") → tên bước (ganLyDo)
    const ly = (s: string | null): (string | HTMLElement)[] => (s ? [" — ", lyDoSpan(lyDoDeHieu(s) ?? s)] : []);
    const ketQua: (string | HTMLElement)[] = b.trangThai === "bo_qua" ? ["bỏ qua", ...ly(b.lyDo ?? "")]
      : b.ketThuc ? (b.trangThai === "done" ? (lo.mode === "draft" ? (b.sach ? ["xong, sạch", ...ly(b.lyDo)] : ["xong nhưng chưa sạch", ...ly(b.lyDo)]) : ["xong"]) : ["dừng", ...ly(b.lyDo ?? runStatusText(b.trangThai))])
        : [b.trangThai === "paused_approval" ? "đang chờ bạn duyệt" : b.trangThai === "cho_gian_cach" || b.trangThai === "cho_den_luot" ? choToiLuot(b, lo) : "đang chạy…"];
    const lop = b.trangThai === "bo_qua" ? "muted" : b.ketThuc ? (b.trangThai === "done" && (lo.mode === "live" || b.sach) ? "ok" : "err") : "running";
    const phu: HTMLElement[] = [];
    if (b.ma === "not_whitelisted") {
      const bot = layBots().find((x) => x.id === b.botId);
      const kb = layKb();
      if (bot && kb.bundleName) {
        const cho = h("button", { type: "button", class: "mini", "data-testid": "nb-cho-phep", title: "Thêm kịch bản này vào danh sách được chạy thật của bot (như ở trang Bot) rồi bấm Chạy thật lần nữa" }, `Cho phép chạy thật trên “${bot.name}”`);
        cho.addEventListener("click", () => void busy(cho, "…", async () => {
          try { const moi = await api<Bot>("PATCH", `/api/bots/${encodeURIComponent(bot.id)}`, { liveAllowed: [...new Set([...bot.liveAllowed, kb.bundleName!])] }); doiBot(moi); toast(`Đã cho phép chạy thật trên ${bot.name} — tick bot rồi bấm Chạy thật lần nữa`); }
          catch (e) { toast(errMsg(e), "err"); }
        }));
        phu.push(cho);
      }
    }
    if (b.choDuyet) {
      const cd = b.choDuyet;
      const gui = (ok: boolean, btn: HTMLButtonElement) => void busy(btn, "…", async () => {
        try { await api("POST", `/api/runs/${encodeURIComponent(cd.runKey)}/approve`, { approved: ok }); toast(ok ? "Đã duyệt" : "Đã từ chối"); await tai(); hoiLai(); } catch (e) { toast(errMsg(e), "err"); }
      });
      const duyet = h("button", { type: "button", class: "ok mini", "data-testid": "nb-duyet", title: "Cho bot này làm bước này (gửi/đăng thật)" }, "Duyệt");
      const tuChoi = h("button", { type: "button", class: "mini", "data-testid": "nb-tu-choi", title: "Không cho bot này làm bước này" }, "Từ chối");
      duyet.addEventListener("click", () => gui(true, duyet));
      tuChoi.addEventListener("click", () => gui(false, tuChoi));
      phu.push(h("div", { class: "warn-box nb-cho-duyet" }, h("b", {}, "Chờ bạn duyệt: "), cd.moTa, cd.noiDung ? h("p", { class: "kb-noi-dung" }, `“${cd.noiDung}”`) : null, h("div", { class: "row" }, duyet, tuChoi)));
    }
    const truoc = lo.canaryBotId && lo.canaryBotId === b.botId ? h("span", { class: "tag muted small", "data-testid": "nb-bot-truoc", title: "Bot này chạy trước; xong không lỗi máy mới cho các bot còn lại chạy" }, "bot chạy trước") : null;
    return h("li", { class: `nb-dong ${lop}`, "data-testid": "nb-dong", dataset: { botId: b.botId, trangThai: b.trangThai } },
      h("b", { class: "nb-ten" }, b.botName), truoc, h("span", { class: "nb-kq", "data-testid": "nb-kq" }, ...ketQua), ...phu);
  }

  /** "đang chờ tới lượt (bắt đầu lúc hh:mm)" — giờ dự kiến của máy chủ (khác ngày thì kèm ngày); chưa có giờ vì chờ bot chạy trước → nói rõ. */
  function choToiLuot(b: BotLo, lo: Lo): string {
    if (!b.batDauLuc) return lo.canaryBotId && lo.canaryBotId !== b.botId ? "đang chờ bot chạy trước xong" : "đang chờ tới lượt";
    const gio = fmtDuKien({ status: b.trangThai, plannedAt: b.batDauLuc });
    const homNay = fmtTime(new Date().toISOString()).split(" ")[0] ?? "";
    return gio ? `đang chờ tới lượt (bắt đầu lúc ${gio.startsWith(`${homNay} `) ? gio.slice(homNay.length + 1) : gio})` : "đang chờ tới lượt";
  }

  /** Hộp cam khi bot chạy trước bị trang web từ chối (job canary_hoi): Tiếp tục / Huỷ ngay trong thẻ. */
  function hopThuTruoc(lo: Lo): HTMLElement | null {
    const truoc = lo.bots.find((b) => b.botId === lo.canaryBotId);
    const conLai = lo.bots.filter((b) => b.botId !== lo.canaryBotId && b.trangThai !== "bo_qua" && !b.ketThuc).length;
    if (lo.jobTrangThai === "cho_canary" && truoc) return h("p", { class: "small muted", "data-testid": "nb-canary-dang" }, `Đang chạy trên 1 bot trước (${truoc.botName}) — xong không lỗi máy mới chạy ${conLai} bot còn lại.`);
    if (lo.jobTrangThai === "canary_that_bai") return h("div", { class: "err-box", "data-testid": "nb-canary-loi" }, h("b", {}, "Bot chạy trước bị lỗi"), ` — các bot còn lại không chạy.${truoc ? ` ${truoc.botName}: ` : ""}`, truoc?.lyDo ? lyDoSpan(lyDoDeHieu(truoc.lyDo) ?? truoc.lyDo) : "");
    if (lo.jobTrangThai !== "canary_hoi") return null;
    const tiep = h("button", { type: "button", class: "pri", "data-testid": "nb-canary-tiep", title: "Cho các bot còn lại chạy tiếp dù bot chạy trước bị trang web từ chối" }, "Tiếp tục");
    const huy = h("button", { type: "button", class: "danger", "data-testid": "nb-canary-huy", title: "Huỷ: các bot còn lại không chạy" }, "Huỷ");
    const quyet = (tiepTuc: boolean, nut: HTMLButtonElement) => void busy(nut, "…", async () => {
      const khac = tiepTuc ? huy : tiep;
      khac.disabled = true;
      try {
        await api("POST", `/api/jobs/${encodeURIComponent(lo.jobId)}/canary-continue`, { continue: tiepTuc });
        toast(tiepTuc ? "Đã cho chạy tiếp trên các bot còn lại" : "Đã huỷ — các bot còn lại không chạy");
        await tai(); hoiLai();
      } catch (e) { toast(errMsg(e), "err"); khac.disabled = false; }
    });
    tiep.addEventListener("click", () => quyet(true, tiep));
    huy.addEventListener("click", () => quyet(false, huy));
    return h("div", { class: "warn-box nb-canary-hoi", "data-testid": "nb-canary-hoi" },
      h("b", {}, "Bot chạy trước bị trang web từ chối"),
      h("p", { class: "small" }, `${truoc?.botName ?? "Bot chạy trước"} dừng: `, lyDoSpan(lyDoDeHieu(truoc?.lyDo ?? lo.jobLyDo) ?? "trang web không nhận việc vừa làm"),
        `. Có thể là kết quả đúng (ví dụ tài khoản chưa là thành viên nhóm). Chạy tiếp trên ${conLai} bot còn lại?`),
      h("div", { class: "row wrap" }, tiep, huy));
  }

  function bangLo(lo: Lo): HTMLElement {
    const nhan = lo.mode === "draft" ? "Chạy thử" : "Chạy thật";
    const dung = h("button", { type: "button", class: "danger mini", "data-testid": lo.mode === "draft" ? "nb-dung-nhap" : "nb-dung-that", title: "Dừng lệnh này trên mọi bot: bot chưa bắt đầu thì huỷ, bot đang chạy nhận lệnh dừng" }, "Dừng");
    dung.addEventListener("click", () => void busy(dung, "Đang dừng…", async () => {
      try { await api("POST", `/api/jobs/${encodeURIComponent(lo.jobId)}/cancel`, {}); toast(`Đã gửi lệnh dừng ${nhan.toLowerCase()} trên các bot`); await tai(); hoiLai(); } catch (e) { toast(errMsg(e), "err"); }
    }));
    const xong = lo.bots.filter((b) => b.ketThuc && b.trangThai !== "bo_qua").length;
    const tong = lo.bots.filter((b) => b.trangThai !== "bo_qua").length;
    const chuaPhep = lo.bots.filter((b) => b.trangThai === "bo_qua" && b.ma === CHUA_PHEP).map((b) => ({ botId: b.botId, botName: b.botName, lyDo: b.lyDo ?? "", ma: b.ma }));
    return h("div", { class: "nb-lo", "data-testid": lo.mode === "draft" ? "nb-lo-nhap" : "nb-lo-that" },
      h("div", { class: "row between wrap" },
        h("b", {}, `${nhan} trên nhiều bot: `, h("span", { "data-testid": "nb-tien-do" }, lo.ketThuc ? `xong ${xong}/${tong} bot` : `${xong}/${tong} bot đã xong`)),
        h("span", { class: "row wrap" }, lo.dungDuoc ? dung : null, h("a", { href: `#/jobs/${encodeURIComponent(lo.jobId)}`, title: "Mở trang tiến độ lần chạy này" }, "xem tiến độ"))),
      hopThuTruoc(lo),
      chuaPhep.length >= 2 ? h("div", { class: "row wrap" }, nutChoPhepNhieu(chuaPhep, "nb-lo-cho-phep-tat-ca", () => toast("Tick các bot rồi bấm Chạy thật lần nữa"))) : null,
      h("ul", { class: "nb-ds" }, ...lo.bots.map((b) => dongBot(b, lo))));
  }

  // ---- đúng 1 bot: API MỘT bot (POST /nhap, /chay-that) — giữ nguyên hành vi thẻ "Chạy trên một bot" cũ ----
  const loiMotEl = (): HTMLElement | null => box.querySelector<HTMLElement>('[data-testid="kb-chay-loi"]');
  const baoLoiMot = (e: unknown, sauLoi?: HTMLElement): void => {
    if (baoNeuBuocDo(e)) return; // máy chủ từ chối vì bước đỏ → danh sách bước đỏ (kb-chay-do)
    const l = loiMotEl();
    if (!l) { toast(errMsg(e), "err"); return; }
    l.textContent = errMsg(e);
    l.hidden = false;
    if (sauLoi) l.append(" ", sauLoi);
  };
  /** Nút "Cho phép chạy thật trên <bot>": thêm kịch bản vào liveAllowed của bot (như trang Bot) rồi bấm Chạy thật lần nữa. */
  function nutChoPhepMot(b: Bot, bundle: string): HTMLButtonElement {
    const cho = h("button", { type: "button", class: "mini", "data-testid": "kb-cho-phep", title: "Thêm kịch bản này vào danh sách được chạy thật của bot (như ở trang Bot)" }, `Cho phép chạy thật trên “${b.name}”`);
    cho.addEventListener("click", () => void busy(cho, "…", async () => {
      try {
        const moi = await api<Bot>("PATCH", `/api/bots/${encodeURIComponent(b.id)}`, { liveAllowed: [...new Set([...b.liveAllowed, bundle])] });
        doiBot(moi);
        toast(`Đã cho phép chạy thật trên ${b.name} — bấm Chạy thật lần nữa`);
        const l = loiMotEl(); if (l) l.hidden = true;
      } catch (e2) { toast(errMsg(e2), "err"); }
    }));
    return cho;
  }
  async function chayThuMot(botId: string): Promise<void> {
    const kb = layKb();
    const l0 = loiMotEl(); if (l0) l0.hidden = true;
    loiMayChu = null;
    await mot.choXong(); // sơ đồ trên màn hình phải là bản đã lưu trước khi chạy
    try {
      const r = await api<{ jobId: string; kichBan: unknown }>("POST", `/api/kich-ban/${encodeURIComponent(kb.id)}/nhap`, { botId });
      toast("Đã gửi kịch bản xuống bot và bắt đầu chạy thử");
      mot.sauChayMot(r.kichBan);
    } catch (e) { baoLoiMot(e); }
  }
  async function chayThatMot(botId: string, nut: HTMLButtonElement): Promise<void> {
    const kb = layKb();
    const bot = layBots().find((b) => b.id === botId);
    const soTuDong = mot.soBuocTuDong();
    const ok = await confirmBox({ title: "Chạy thật?", text: `Bot “${bot?.name ?? ""}” sẽ làm THẬT các bước của kịch bản “${kb.ten}”. ${soTuDong ? `${soTuDong} bước đặt TỰ ĐỘNG sẽ gửi/đăng KHÔNG hỏi duyệt (bạn chịu trách nhiệm nội dung); bước rủi ro cao còn lại dừng hỏi bạn duyệt trước khi làm.` : "Bước rủi ro cao (gửi/đăng/thích) dừng hỏi bạn duyệt trước khi làm."}`, nhac: kb.chuaGanSp ? NHAC_CHAY_THAT_SP : undefined, okText: "Chạy thật", danger: true });
    if (!ok) return;
    // KIỂM TRƯỚC (02/10/2026): kịch bản chưa có trong danh sách được chạy thật của bot → máy chủ chắc chắn trả 403 not_whitelisted. Báo ngay bằng đúng
    // câu máy chủ sẽ nói, không gửi gì (console không còn "Failed to load resource: 403"); bảng bot cũ (tab khác vừa cho phép) thì vẫn gửi và máy chủ quyết.
    // Chỉ báo trước khi CHẮC máy chủ sẽ dừng ở bước whitelist (bot trực tuyến + bot có kịch bản này).
    const botNay = mot.botMoiNhat(botId) ?? bot;
    if (botNay && kb.bundleName && botNay.online && botNay.bundles.some((x) => x.name === kb.bundleName) && !botNay.liveAllowed.includes(kb.bundleName)) {
      baoLoiMot(new Error(`${MSG_CHUA_DUOC_CHAY_THAT} — ${botNay.name}: ${MSG_CHUA_WHITELIST}`), nutChoPhepMot(botNay, kb.bundleName));
      return;
    }
    await busy(nut, "Đang gửi…", async () => {
      const l = loiMotEl(); if (l) l.hidden = true;
      loiMayChu = null;
      try {
        const r = await api<{ jobId: string; kichBan: unknown }>("POST", `/api/kich-ban/${encodeURIComponent(kb.id)}/chay-that`, { botId });
        toast("Đã bắt đầu chạy thật");
        mot.sauChayMot(r.kichBan);
      } catch (e) {
        if (e instanceof ApiError && e.code === "not_whitelisted" && bot && kb.bundleName) baoLoiMot(e, nutChoPhepMot(bot, kb.bundleName));
        else baoLoiMot(e);
      }
    });
  }

  /** Khoá nút theo số bot đã tick: ≥ 2 bot → chỉ khoá lúc đang gửi (máy chủ xét từng bot); 1 bot → phải trực tuyến, Chạy thật còn cần cổng chạy thử sạch. */
  function khoaNut(): { thu: boolean; that: boolean } {
    if ((mot.buocDo?.() ?? []).length) return { thu: dangGui, that: dangGui }; // còn bước ĐỎ: vẫn bấm được — bấm để xem danh sách bước đỏ (không khoá vì bot / cổng chạy thử)
    if (chon.size >= 2) return { thu: dangGui, that: dangGui };
    const b = chon.size === 1 ? layBots().find((x) => x.id === [...chon][0]) : undefined;
    const ok = !!b && b.online && !dangGui;
    return { thu: !ok, that: !ok || !mot.choChayThat().duoc };
  }

  function ve(): void {
    if (!song) return;
    const kb = layKb();
    const cuonCu = box.querySelector<HTMLElement>('[data-testid="nb-chon"]')?.scrollTop ?? 0; // lần hỏi lại 1,5 s vẽ lại thẻ: danh sách bot dài giữ chỗ cuộn
    clear(box);
    if (kb.trangThai !== "san_sang" || !kb.coSoDo) return;
    const bots = layBots();
    if (choChonSan && bots.length) { for (const id of choChonSan) if (bots.some((b) => b.id === id)) chon.add(id); choChonSan = null; }
    if (!daTuChon) { const md = mot.macDinh(); chon.clear(); if (md && bots.some((b) => b.id === md)) chon.add(md); }
    for (const id of [...chon]) if (!bots.some((b) => b.id === id)) chon.delete(id);
    const goiY = new Set(kb.botGoiY ?? []);
    const ds = h("div", { class: "nb-chon", "data-testid": "nb-chon" }, ...bots.map((b) => {
      const o = h("input", { type: "checkbox", value: b.id, checked: chon.has(b.id), "data-testid": "nb-tick", title: `Chọn ${b.name}` }) as HTMLInputElement;
      o.addEventListener("change", () => { daTuChon = true; if (o.checked) chon.add(b.id); else chon.delete(b.id); kiem = null; ve(); });
      return h("label", { class: "inline nb-bot", dataset: { botId: b.id } }, o, h("span", {}, b.name), h("span", { class: `small ${b.online ? "ok" : "muted"}` }, b.online ? " · trực tuyến" : " · ngoại tuyến"), goiY.has(b.id) ? h("span", { class: "small muted" }, " · đã chạy mạng này") : null,
        // L-99: mọi mạng bot đã chạy được + chip đỏ “Tạm dừng: CAPTCHA (TikTok)” (đủ để chọn đúng bot TRƯỚC khi bấm, thay vì bị 409 sau khi bấm).
        ...chipBotMang(botMang[b.id], tenMangTrang));
    }));
    const tatCa = h("button", { type: "button", class: "mini", "data-testid": "nb-chon-tat-ca", title: "Chọn mọi bot đang trực tuyến đã từng chạy việc trên mạng của kịch bản này (chưa có bot nào như vậy thì chọn mọi bot trực tuyến)" }, "Chọn tất cả bot trực tuyến phù hợp nền tảng");
    tatCa.addEventListener("click", () => { daTuChon = true; chon.clear(); for (const id of phuHop()) chon.add(id); kiem = null; ve(); });
    const boChon = h("button", { type: "button", class: "mini", "data-testid": "nb-bo-chon", title: "Bỏ chọn mọi bot" }, "Bỏ chọn");
    boChon.addEventListener("click", () => { daTuChon = true; chon.clear(); kiem = null; ve(); });
    const n = chon.size;
    const nhieu = n >= 2;
    const botMot = n === 1 ? bots.find((b) => b.id === [...chon][0]) : undefined;
    const botDon = botMot ? botMot.id : "";
    const ct = mot.choChayThat();
    // MỘT cặp nút: testid kb-nhap / kb-that cho cả hai chế độ; chữ + cổng đổi theo số bot đã tick.
    const kn = khoaNut();
    const thu = h("button", { type: "button", "data-testid": "kb-nhap", disabled: kn.thu,
      title: nhieu ? "Chạy thử trên các bot đã chọn: làm bước an toàn, bước gửi/đăng chỉ ghi lại (không đăng gì)" : "Chạy thử trên bot: làm các bước an toàn, bước gửi/đăng chỉ ghi lại (không đăng gì)" }, nhieu ? `Chạy thử trên ${n} bot` : "Chạy thử");
    const that = h("button", { type: "button", class: "danger", "data-testid": "kb-that", disabled: kn.that,
      title: nhieu ? "Chạy thật trên các bot đã chọn — máy kiểm trước từng bot (đã chạy thử sạch bản hiện tại, được phép chạy thật…) rồi mới hỏi bạn xác nhận" : ct.duoc ? "Chạy thật: bot làm thật; bước rủi ro cao dừng hỏi duyệt" : ct.lyDo }, nhieu ? `Chạy thật trên ${n} bot` : "Chạy thật");
    const loi = h("div", { class: "err-box", hidden: true, "data-testid": "nb-loi" });
    const loiChay = h("div", { class: "err-box", hidden: true, "data-testid": "kb-chay-loi" });
    // (07/10/2026, GĐ0 pha B) danh sách BƯỚC ĐỎ khi bấm Chạy mà sơ đồ còn đỏ (theo sơ đồ đang hiện; hoặc danh sách máy chủ trả khi trang chưa biết) — mỗi dòng có nút "Tới bước n".
    const dsDoNay = mot.buocDo?.() ?? [];
    if (bamDo && !dsDoNay.length) bamDo = false; // đã sửa hết đỏ → danh sách tự tắt
    const hienDo = bamDo ? dsDoNay : loiMayChu;
    const hopDo = hienDo?.length ? h("div", { class: "err-box kb-chay-do", role: "alert", "data-testid": "kb-chay-do" },
      h("b", { "data-testid": "kb-chay-do-tieu-de" }, `Chưa chạy được — còn ${new Set(hienDo.map((x) => x.soThuTu)).size} bước đỏ (thiếu đầu vào):`),
      h("ul", {}, ...hienDo.map((x) => {
        const nhay = h("button", { type: "button", class: "mini", "data-testid": "kb-chay-do-nhay", title: `Cuộn tới bước ${x.soThuTu} trong sơ đồ` }, `Tới bước ${x.soThuTu}`);
        nhay.addEventListener("click", () => mot.nhayToiBuoc?.(x.soThuTu));
        return h("li", { "data-testid": "kb-chay-do-dong", dataset: { so: String(x.soThuTu) } }, h("span", { class: "kb-co-bieu", "aria-hidden": "true" }, "⛔"), ` ${x.loi} `, nhay);
      }))) : null;
    const baoBoQua = (mode: string, list: BoQua[]): void => { boQuaMoi = list.length ? { mode, ds: list } : null; };
    const gui = async (mode: "draft" | "live", them: { gianCachS?: number } = truongThem(mode, chon.size)): Promise<void> => {
      if (dangGui) return;
      dangGui = true;
      loi.hidden = true;
      boQuaMoi = null;
      loiMayChu = null;
      try {
        const r = await api<TrangThai & { chay: string[]; boQua: BoQua[] }>("POST", `/api/kich-ban/${encodeURIComponent(kb.id)}/${mode === "draft" ? "nhap-nhieu" : "chay-that-nhieu"}`, { botIds: [...chon], ...them });
        tt = { nhap: r.nhap, that: r.that };
        baoBoQua(mode, r.boQua);
        toast(`${mode === "draft" ? "Đã bắt đầu chạy thử" : "Đã bắt đầu chạy thật"} trên ${r.chay.length} bot${r.boQua.length ? ` (bỏ qua ${r.boQua.length} bot — xem lý do)` : ""}`);
        ve();
        hoiLai();
        sauGui();
      } catch (e) {
        if (buocDoTuLoi(e)) { dangGui = false; baoNeuBuocDo(e); return; } // bước đỏ (máy chủ từ chối): danh sách bước đỏ, không phải "bot bị bỏ qua"
        const ds2 = e instanceof ApiError && e.details && typeof e.details === "object" ? (e.details as { boQua?: BoQua[] }).boQua ?? [] : [];
        baoBoQua(mode, ds2);
        ve();
        const l = box.querySelector<HTMLElement>('[data-testid="nb-loi"]');
        if (l) { l.textContent = errMsg(e); l.hidden = false; }
      } finally {
        dangGui = false;
        const t1 = box.querySelector<HTMLButtonElement>('[data-testid="kb-nhap"]'), t2 = box.querySelector<HTMLButtonElement>('[data-testid="kb-that"]');
        const kh = khoaNut();
        if (t1 && t1 !== thu) t1.disabled = kh.thu;
        if (t2 && t2 !== that) t2.disabled = kh.that;
      }
    };
    guiHienTai = gui;
    thu.addEventListener("click", () => {
      if (chanNeuDo()) return; // (07/10/2026) còn bước đỏ → hiện danh sách bước đỏ, không gọi API
      if (chon.size >= 2) {
        if (kiemGc("draft")) return; // số giây tự nhập sai → báo dưới ô, không gửi
        void busy(thu, "Đang gửi xuống các bot…", async () => { kiem = null; await mot.choXong(); return gui("draft"); });
      } else if (botDon) void busy(thu, "Đang gửi xuống bot…", () => chayThuMot(botDon));
    });
    that.addEventListener("click", () => { if (chanNeuDo()) return; if (chon.size >= 2) void chayThat(that); else if (botDon) void chayThatMot(botDon, that); });
    const bq = boQuaMoi;
    const k = kiem;
    tuyChon.hidden = !nhieu;
    if (nhieu) kiemGc(); else gcLoi.hidden = true;
    const dangGo = tuyChon.contains(document.activeElement) ? (document.activeElement as HTMLElement) : null;
    loBox = h("div", { "data-testid": "nb-lo-vung" });
    veLo();
    // Dòng nói vì sao chưa chọn được / chưa chạy được (chỉ khi chưa chọn nhiều bot).
    const botTt = nhieu ? "" : !bots.length ? MSG_CHUA_CO_BOT : !botMot ? MSG_CHUA_CHON_BOT : botMot.online ? "" : `Bot “${botMot.name}” đang ngoại tuyến — bật bot rồi chạy thử`;
    box.append(h("div", { class: "card", "data-testid": "kb-chay" },
      h("h3", {}, "Chạy kịch bản"),
      h("div", { "data-testid": "nb-the" },
      h("p", { class: "small muted" }, "Tick bot rồi bấm Chạy thử hoặc Chạy thật — chọn 1 bot hoặc nhiều bot. Chọn nhiều bot: máy xét TỪNG bot (bot tắt, đang bận, chưa chạy thử sạch bản hiện tại, chưa được phép chạy thật… sẽ bị bỏ qua kèm lý do — các bot còn lại vẫn chạy)."),
      bots.length ? ds : null,
      botTt ? h("p", { class: "small warn", "data-testid": "kb-bot-tt" }, botTt) : null,
      ...[...chon].flatMap((id) => { const b = bots.find((x) => x.id === id); const c = b ? canhBaoBotMang(b.name, botMang[id], kb.nenTang || null, tenMangTrang) : null; return c ? [h("p", { class: `small ${c.loai === "tam-dung" ? "err" : "warn"}`, "data-testid": "nb-canh-bao-mang", dataset: { botId: id, loai: c.loai } }, `⚠ ${c.chu}`)] : []; }),
      h("div", { class: "row wrap" }, tatCa, boChon, h("span", { class: "small muted", "data-testid": "nb-da-chon" }, `Đã chọn ${n} bot`)),
      ...mot.theTuDong(),
      tuyChon,
      h("div", { class: "row kb-nut-chay" }, thu, that, ...mot.nutPhu()),
      // Trạng thái "chạy thử sạch → được chạy thật" DÙNG CHUNG cho cả hai chế độ (V8: một nguồn, không mâu thuẫn với dòng kết quả nhiều bot).
      h("p", { class: `small ${ct.duoc ? "ok" : "muted"} ly-do-chan`, "data-testid": "kb-that-ly-do" }, ct.duoc ? "✓ Chạy thử sạch đúng bản hiện tại — được chạy thật" : `Chạy thật: ${ct.lyDo}`),
      hopDo,
      loiChay,
      loi,
      ...mot.veLanChay(),
      k ? h("div", { class: k.chay.length ? "warn-box nb-kiem" : "err-box nb-kiem", "data-testid": "nb-kiem" },
        h("b", { "data-testid": "nb-kiem-tieu-de" }, k.chay.length ? `Chạy thật được trên ${k.chay.length}/${k.chay.length + k.boQua.length} bot` : `Không bot nào chạy thật được (${k.boQua.length} bot)`),
        k.chay.length ? h("p", { class: "small", "data-testid": "nb-kiem-chay" }, `Sẽ chạy: ${k.chay.map((x) => x.botName).join(", ")}`) : null,
        k.boQua.length ? h("ul", {}, ...k.boQua.map((x) => h("li", { "data-testid": "nb-kiem-dong", dataset: { botId: x.botId, ma: x.ma ?? "" } }, `${x.botName}: `, lyDoSpan(x.lyDo)))) : null,
        h("div", { class: "row wrap" }, nutChoPhepNhieu(k.boQua, "nb-kiem-cho-phep", () => void chayThat(null)))) : null,
      bq ? h("div", { class: "warn-box", "data-testid": "nb-bo-qua" }, h("b", {}, `Bot bị bỏ qua khi ${bq.mode === "draft" ? "chạy thử" : "chạy thật"}:`),
        h("ul", {}, ...bq.ds.map((x) => h("li", { "data-testid": "nb-bo-qua-dong" }, `${x.botName}: `, lyDoSpan(x.lyDo)))),
        bq.mode === "live" ? h("div", { class: "row wrap" }, nutChoPhepNhieu(bq.ds, "nb-bo-qua-cho-phep", () => void chayThat(null))) : null) : null,
      loBox,
      kb.bundleName ? h("p", { class: "small nb-lich-su" }, h("a", { href: `#/history?bundleName=${encodeURIComponent(kb.bundleName)}`, "data-testid": "nb-lich-su", title: "Mở Lịch sử chạy chỉ gồm các lần chạy của kịch bản này (mọi bot)" }, "Lịch sử chạy của kịch bản này")) : null)));
    if (cuonCu) ds.scrollTop = cuonCu;
    // Trang chính vẽ lại thẻ khi người dùng đang gõ số giây → trả con trỏ về đúng ô (ô là cùng phần tử, chữ còn nguyên).
    if (dangGo && tuyChon.isConnected) dangGo.focus();
  }

  /** Phần tiến độ (bảng từng bot của chạy thử / chạy thật) — lần hỏi lại 1,5 s chỉ vẽ lại phần này. */
  function veLo(): void {
    if (!loBox) return;
    clear(loBox);
    loBox.append(...[tt.nhap ? bangLo(tt.nhap) : null, tt.that ? bangLo(tt.that) : null, !daTai ? h("p", { class: "small muted" }, "Đang tải tiến độ…") : null].filter((x): x is HTMLElement => !!x));
  }

  void tai().then(hoiLai).catch((e) => toast(`Không tải được tiến độ chạy nhiều bot: ${errMsg(e)}`, "warn"));
  return { ve, huy: () => { song = false; window.clearTimeout(timer); } };
}
